import React, { lazy, Suspense } from 'react';

import useIntersectionObserver from '../../helpers/useIntersectionObserver';

const NewsletterSubscribe = lazy(
  () => import('./index.lazy'),
);

const NewsletterSubscribeSuspense = () => {
  const [shouldLoad, placeholderRef] = useIntersectionObserver({
    rootMargin: '100% 0px 0px 0px', // Trigger when 50% viewport away
  });

  if (!shouldLoad) return <div ref={placeholderRef} />;

  return (
    <Suspense fallback={<div />}>
      <NewsletterSubscribe />
    </Suspense>
  );
};

export default NewsletterSubscribeSuspense;
